module.exports = __webpack_public_path__ + "img/Pharmacy_6.0dea79c9.png";